import React, { useCallback } from "react"
import PropTypes from "prop-types"
import { Col, Flex, Row } from "antd"
import { TeamOutlined } from "@ant-design/icons"
import { MultiUser } from "ui/Icon/DSIcon/MultiUser"
import styles from "../../index.module.css"

const OPTIONS = [
  {
    key: "adult",
    icon: MultiUser,
    label: "Guest Age 18+"
  },
  {
    key: "guardian",
    icon: TeamOutlined,
    label: "Legal Guardian and Minors"
  }
]

export const WaiverOptions = ({ selected, onSelect, className }) => {
  const handleOptionClick = useCallback(
    (key) => {
      onSelect(key)
    },
    [onSelect]
  )

  return (
    <Row gutter={[20, 20]} className={className}>
      {OPTIONS.map((opt) => {
        const IconComp = opt.icon
        const isSelected = selected === opt.key
        const cardClassName = isSelected
          ? `${styles.optionCard} 
             ${styles.optionCardSelected} 
             py-xl 
             px-l`
          : `${styles.optionCard} 
             py-xl 
             px-l`
        const iconClassName = isSelected
          ? `${styles.optionIcon} 
             ${styles.optionIconSelected}`
          : styles.optionIcon

        return (
          <Col md={12} span={24}>
            <div
              key={opt.key}
              className={cardClassName}
              onClick={() => handleOptionClick(opt.key)}
              role="button"
              tabIndex={0}
              aria-pressed={isSelected}
              onKeyDown={(e) => {
                if (e.key === "Enter" || e.key === " ") {
                  handleOptionClick(opt.key)
                  e.preventDefault()
                }
              }}
            >
              <Flex justify="center" align="center" className={iconClassName}>
                <IconComp />
              </Flex>
              <Flex justify="space-between" align="center" className={`mb-l ml-0 p-s ${styles.multiUserIcon}`}>
                {/* <MultiUser /> */}
              </Flex>
              <div className={styles.optionLabel}>{opt.label}</div>
            </div>
          </Col>
        )
      })}
    </Row>
  )
}

WaiverOptions.propTypes = {
  selected: PropTypes.string.isRequired,
  onSelect: PropTypes.func.isRequired,
  className: PropTypes.string
}
